import React from "react";
import { UltravioletCaptureProperty } from '../../../Model/CaptureProfile';
import EOpticAndCameraFeature from "../../../Model/EOpticAndCameraFeature";
import { CropZoom } from "../../../Model/ImagerCapabilities";
import { BasicControl } from "../ImagerFeatureControls";

type CropZoomControlProps = {
  disabled: boolean;
  cropZoom: CropZoom;
  captureProperty: UltravioletCaptureProperty;
  onChange: (value: { cropZoom: number }) => void;
};

export function CropZoomControl({ cropZoom, captureProperty, disabled, onChange }: CropZoomControlProps) {
  if (captureProperty.cropZoom == null) {
    throw new Error("Capture profile cropZoom is null");
  }
  return (
    <BasicControl
      disabled={disabled}
      feature="Zoom"
      id={EOpticAndCameraFeature.CropZoom}
      min={cropZoom.minCropZoom}
      max={cropZoom.maxCropZoom}
      value={captureProperty.cropZoom}
      onValueChanged={(id, value) => {
        onChange({
          cropZoom: value,
        });
      }}
      unit="x"
      step={0.1}
    />
  );
}
